/**
 *  This library contains the actions and state relating to the login experience.
 */
import _ from 'lodash';
import URLs from '../../Urls';
import Const from './ActionConst';
import { getAuthHeaders } from '../../../auth';
import { CommonActions } from './common.actions';
import { API_LOGOUT_ENDPOINT, ROUTER_DIRS } from '../../Constants';

const Actions = {
  loginActions: [],
  login: CommonActions.login,
  isLoggedIn: CommonActions.isLoggedIn,
  async logout(dispatch) {
    const doLogout = _.once(result => {
      let idmLogoutUrl;
      try {
        ({ idmLogoutUrl } = _.isString(result) ? JSON.parse(result) : result);
      } catch {
        idmLogoutUrl = null;
      }

      if (idmLogoutUrl) {
        dispatch({
          type: Const.Login.LOGOUT,
          idmLogoutUrl,
          returnToUrl: window.location.href,
        });
        URLs.goTo(ROUTER_DIRS.LOGOUT);
        return;
      }

      throw new Error('idmLogoutUrl not provided');
    });

    const headers = await getAuthHeaders({});
    return fetch(API_LOGOUT_ENDPOINT, {
      credentials: 'include',
      headers,
    })
      .then(async res => {
        if (res.status !== 200) {
          return Actions.onFailure(
            dispatch,
            () => URLs.goTo(ROUTER_DIRS.LOGOUT),
            res,
          );
        }

        let json;
        try {
          json = await res.json();
        } catch {
          json = {};
        }

        doLogout(json);
      })
      .catch(error => {
        console.error(error?.message);
        URLs.goTo(ROUTER_DIRS.LOGOUT);
      });
  },
  onFailure(dispatch, callback, event) {
    if (event.status === 401 /* UNAUTHORIZED */) {
      URLs.goTo(ROUTER_DIRS.LOGIN);
    } else {
      callback.call(this, dispatch, event);
    }
  },
};

export default Actions;
